export default "__VITE_ASSET__f25ad83b__"